export default __webpack_public_path__ + "static/media/tg.bbb0ed4b.svg";